import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaBell } from "react-icons/fa";
import "../styles/configPushcut.css";

const ConfigPushcut = () => {
  const [pushcutUrl, setPushcutUrl] = useState("");
  const [mensagem, setMensagem] = useState("");

  useEffect(() => {
    const carregarPushcut = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get("https://api.ticketdovaqueiro.com/api/auth/me", {
          headers: { Authorization: `Bearer ${token}` }
        });
        setPushcutUrl(res.data.pushcutUrl || "");
      } catch (err) {
        console.error("Erro ao carregar pushcut:", err);
      }
    };

    carregarPushcut();
  }, []);

  const salvarPushcut = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      await axios.put(
        "https://api.ticketdovaqueiro.com/api/auth/me/pushcut",
        { pushcutUrl },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMensagem("✅ URL do Pushcut salva com sucesso!");
    } catch (err) {
      console.error("Erro ao salvar pushcut:", err);
      setMensagem("❌ Erro ao salvar. Verifique o link ou tente novamente.");
    }
  };

  return (
    <div className="config-pushcut">
      <h2><FaBell /> Notificações Pushcut</h2>
      <form onSubmit={salvarPushcut}>
        <label htmlFor="pushcutUrl">Cole aqui sua URL do Pushcut:</label>
        <input
          type="url"
          id="pushcutUrl"
          value={pushcutUrl}
          onChange={(e) => setPushcutUrl(e.target.value)}
          placeholder="https://api.pushcut.io/..."
          required
        />
        <button type="submit">Salvar</button>
      </form>
      {mensagem && <p className="mensagem">{mensagem}</p>}
    </div>
  );
};

export default ConfigPushcut;
